import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingRegistry } from "@services/LoadingRegistry";
import React, { createContext, useCallback, useContext, useEffect, useState, } from "react";
var LoadingContext = createContext(undefined);
// Provider component
export var LoadingProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    // Handlers (using useCallback for stable references)
    var showLoading = useCallback(function () { return setIsLoading(true); }, []);
    var hideLoading = useCallback(function () { return setIsLoading(false); }, []);
    // Memoize the context value for performance
    var value = React.useMemo(function () { return ({ isLoading: isLoading, showLoading: showLoading, hideLoading: hideLoading }); }, [isLoading, showLoading, hideLoading]);
    useEffect(function () {
        LoadingRegistry.start = function () { return showLoading(); };
        LoadingRegistry.stop = function () { return hideLoading(); };
    }, []); // Run once on mount
    return (_jsx(LoadingContext.Provider, { value: value, children: children }));
};
export var useGlobalLoading = function () {
    var loadingContext = useContext(LoadingContext);
    if (!loadingContext)
        throw new Error("useGlobalLoading must be used within LoadingProvider");
    return loadingContext;
};
